import { Autocomplete, Stack, TextField } from '@mui/material';
import { ChangeEvent, FC, memo } from 'react';
import { TruckDriverIdAndName } from 'src/entities/orderEntity';

interface TruckDriverConstraintsSelectorProps {
  truckData: TruckDriverIdAndName[];
  driverData: TruckDriverIdAndName[];
  allowedTrucks: TruckDriverIdAndName[];
  deniedDrivers: TruckDriverIdAndName[];
  onChangeAllowedTrucks: (event: ChangeEvent<HTMLInputElement>, value: TruckDriverIdAndName[]) => void;
  onChangeDeniedDrivers: (event: ChangeEvent<HTMLInputElement>, value: TruckDriverIdAndName[]) => void;
}

/**
 * 指定トラックとNGドライバーを選択するコンポーネント
 */
export const TruckDriverConstraintsSelector: FC<TruckDriverConstraintsSelectorProps> = memo(({
  truckData,
  driverData,
  allowedTrucks,
  deniedDrivers,
  onChangeAllowedTrucks,
  onChangeDeniedDrivers,
}) => {
  return (
    <Stack pt={1} pb={2}>
      <Autocomplete
        multiple
        id="allowd_trucks"
        options={truckData}
        getOptionLabel={(option: TruckDriverIdAndName) => option.name}
        isOptionEqualToValue={(option, v) => option.id === v.id}
        onChange={onChangeAllowedTrucks}
        value={allowedTrucks}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            label="指定トラック"
          />
        )}
      />
      <Autocomplete
        multiple
        id="denied_drivers"
        options={driverData}
        getOptionLabel={(option: TruckDriverIdAndName) => option.name}
        isOptionEqualToValue={(option, v) => option.id === v.id}
        onChange={onChangeDeniedDrivers}
        value={deniedDrivers}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            label="NGドライバー"
          />
        )}
      />
    </Stack>
  );
});

TruckDriverConstraintsSelector.displayName = 'TruckDriverConstraintsSelector';
